import useLoanTypes from '~/hooks/useLoanTypes';
import { useMemo } from 'react';
import { TeamsSearchParams } from '~/contexts/types/teams/searchParams';
import { defaultAmountQuantityRange } from '~/contexts/LoanOfficerSearchParams';

export const useConstants = () => {
  const { loanTypes } = useLoanTypes();

  const defaultValues: TeamsSearchParams = useMemo(
    () => ({
      team: {
        name: '',
        size: { from: '', to: '' },
      },
      company: {
        name: '',
        address: {
          state: '',
          city: '',
          zip: '',
          county: '',
        },
        strict: false,
      },
      office: {
        name: '',
        address: {
          state: '',
          city: '',
          zip: '',
          county: '',
        },
        strict: false,
      },
      transaction_address: {
        state: '',
        city: '',
        zip: '',
        county: '',
      },
      performance: {
        transaction_side: {
          sale: defaultAmountQuantityRange,
          buyer: defaultAmountQuantityRange,
          seller: defaultAmountQuantityRange,
          dual: defaultAmountQuantityRange,
        },
        loan_type: Object.fromEntries(loanTypes.map((type) => [type, defaultAmountQuantityRange])),
      },
      period: 14,
    }),
    [loanTypes]
  );

  return {
    defaultValues,
  };
};
